export const audioVolume = 0.5;
export const defaultLocale = "en";
